module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAMBAMAAACtsOGuAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAnUExURbm/yLe/x0dwTLrBybrBybnBybrByrrBybrBybi/ybe/x7vCybrByT+60mgAAAAMdFJOU2ggAIDv38+V31BAr2u+u6sAAAA8SURBVAjXY1BSUjJgUFISO8ygpOkyiUGpJlGJQey4khJDySIgsYUJSIgeBhJKNo1AQiGCCahY9AADSBsAbk8L0xHwTDAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/left.png
// module id = xDWF
// module chunks = 0